import React from 'react'
import {useCompareData} from './hooks'
import {
  Section,
  Subsection,
} from './Sections'
import Row from './Row'
import Values from './Values'

const nameSorter = (a, b) => a.name.localeCompare(b.name)

const OrganizationTypes = (props) => {
  const {
    systems,
    organizationTypesData,
  } = useCompareData()

  const organizationTypes = organizationTypesData.allIds
    .map(id => organizationTypesData.byId[id])
    .sort(nameSorter)

  return (
    <>
      <Section>Organization Types</Section>
      {organizationTypes.map(({id, name}) => {
        return (
          <React.Fragment key={id}>
            <Subsection>{name}</Subsection>
            <Row>
              {systems.map(s => (
                <Values key={s.id}>
                  {s?.organizationTypes && s.organizationTypes.includes(id) ? 'Yes' : 'No'}
                </Values>
              ))}
            </Row>
          </React.Fragment>
        )
      })}
    </>
  )
}

export default OrganizationTypes
